import actionTypes from '../constants/action-types';

const errorMessage = (state = null, action) => {
  switch (action.type) {
    case actionTypes.SET_ERROR_MESSAGE: {
      return action.payload.message;
    }

    default:
      return state;
  }
};

export default errorMessage;
